import React, { useEffect, useState, useContext, useRef } from "react";
import { ethers } from "ethers";
import config from "../config";
import appProp from "../server";
import { EthersContext, contractInfo } from "../ethers/EthersProvider";
import Verification from "../ethers/Verification";
import { Link, useNavigate } from "react-router-dom";

import "../css/base.css";
import "../css/play.css";

import title_img from "../img/title.png";
import ico_wallet from "../img/icon-wallet.png";
import ico_point from "../img/icon-points.png";
import ico_verify from "../img/icon-verify.png";
import ico_verified from "../img/icon-verified.png";
import ico_card from "../img/icon-card.png";
import card_img from "../img/card.png";
import ico_crown from "../img/icon-crown.svg";
import ico_instruction from "../img/icon-instruction.svg";
import ico_sound_on from "../img/icon-sound.svg";
import ico_sound_off from "../img/icon-sound-off.svg";
import hand_paper from "../img/hand-paper.png";
import hand_rock from "../img/hand-rock.png";
import hand_scissors from "../img/hand-scissors.png";
import win_img from "../img/win.gif";
import loose_img from "../img/lose.gif";
import draw_img from "../img/draw.gif";
import icon_credit from "../img/icon-credit.png";
import icon_master from "../img/iocn-sejong.png";

// Sound
import useSound from "use-sound";
import sound_win from "../assets/win.mp3";
import sound_loose from "../assets/loose.mp3";
import sound_timer from "../assets/timer.mp3";
import sound_handclick from "../assets/hand_click.mp3";
import sound_wait from "../assets/wait.mp3";
import sound_bounce from "../assets/bounce.wav";

import Instruction from "../p_component/Instruction";

import rockImage from "../img/hand-rock.png";
import paperImage from "../img/hand-paper.png";
import scissorsImage from "../img/hand-scissors.png";

import jQuery, { ajaxTransport } from "jquery";
window.$ = window.jQuery = jQuery;

const click_audio = new Audio(sound_handclick);
const timer_audio = new Audio(sound_timer);
const win_audio = new Audio(sound_win);
const loose_audio = new Audio(sound_loose);
const wait_audio = new Audio(sound_wait);
const bounce_audio = new Audio(sound_bounce);

const ABI = config.abi.SquidNFTABI;

//// Game info
const numberOfCardsPerGame = 1;
const numberOfRoundsPerCard = 4;
const pegiWait = 5;

let showCount = 0;

//// Helper ftns
function getElem(elemId) {
  return document.getElementById(elemId);
}
// pick a random within [min, max)
function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min;
}

const RPSSign = {
  1: rockImage,
  2: paperImage,
  3: scissorsImage
};

//////////////////// Game room ///////////////////////
const REQ_CONNECT = "REQ_CONNECT";
const WAIT_GAME = "WAIT_GAME";
const START_GAME = "START_GAME";
const REJECT_GAME = "REJECT_GAME";
const MY_CARDS = "TWO_CARDS";
const CPTY_CARDS = "TWO_CARDS";
const REMOVE_CARD = "REMOVE_CARD";
const FINAL_RESULT = "FINAL_RESULT";
const ROCK = 1; //"R"
const PAPER = 2; //"P"
const SCISSORS = 3; //"S"

// return -1 when c1 wins, 0 in draw, 1 when c2 wins
const RPS = (c1, c2) => {
  if (c1 === c2) {
    return 0;
  }
  if (c1 === ROCK) {
    if (c2 === PAPER) {
      return 1;
    } else {
      return -1;
    }
  }
  if (c1 === PAPER) {
    if (c2 === SCISSORS) {
      return 1;
    } else {
      return -1;
    }
  }
  if (c1 === SCISSORS) {
    if (c2 === ROCK) {
      return 1;
    } else {
      return -1;
    }
  }
};

const postData = async (url = "", data = {}) => {
  return fetch(url, {
    method: "POST",
    mode: "cors",
    cache: "no-cache",
    // credentials: 'same-origin', // include, *same-origin, omit
    headers: {
      "Content-Type": "application/json"
    },
    redirect: "follow",
    referrer: "no-referrer",
    body: JSON.stringify(data)
  }).then(response => {
    if (response.ok) {
      return response.json();
    }
  });
};

////////////////////////////////////////////////////////////////////

const HanapegiPlay = props => {
  const {
    provider,
    signer,
    account,
    setAccount,
    networkId,
    setNetworkId,
    verified,
    setVerified,
    initialized,
    setWalletConnect
  } = useContext(EthersContext);

  const navigate = useNavigate();
  const [myinfo, setMyInfo] = useState(null);
  const [mypoint, setMyPoint] = useState(0);
  const [mycredit, setMyCredit] = useState(null);

  const masterCardCnt = 5;

  const [initcomplete, setInitComplete] = useState(false);
  const [cardBalance, setCardBalance] = useState(-1);
  const [cardBalanceMaster, setMasterCardBalance] = useState(0);
  const [nftInstance, setNftInstance] = useState(null);
  const [gameCards, setGameCards] = useState([]);
  const [selectedTokenImage, setSelectedTokenImage] = useState(null);
  const [selectedTokenID, setSelectedTokenID] = useState("");
  const [selectedTokenGenes, setSelectedTokenGenes] = useState("");
  const [waiting, setWaiting] = useState(false);

  const [showResult, setShowResult] = useState(false);
  const [finalwin, setWin] = useState(false);
  const [finallose, setLose] = useState(false);
  const [finaldraw, setDraw] = useState(false);
  const [bannerMessage, setBannerMessage] = useState("");
  const [cardPrepared, setCardPrepared] = useState(false);

  const [myRPS1Image, setMyRPS1Image] = useState(null);
  const [myRPS2Image, setMyRPS2Image] = useState(null);
  const [cptyRPS1Image, setCptyRPS1Image] = useState(null);
  const [cptyRPS2Image, setCptyRPS2Image] = useState(null);

  const [myCards, setMyCards] = useState([]);
  const [masterCards, setMasterCards] = useState([]);
  const [curRound, setCurRound] = useState(0);
  const [cardSelected, setCardSelected] = useState(false);
  const [playerInfo, setPlayerInfo] = useState({
    isMaster: false,
    Address: "",
    discordId: ""
  });

  const [soundOn, setSoundOn] = useState(true);

  let counter; // Interval
  let timerAutoChoice; // Timer

  useEffect(() => {
    window.$(document).ready(function () {
      let tv_width = window.$("#tv").outerWidth();
      window.$("#tv").css("height", tv_width / 1.77);

      window.$(window).resize(function () {
        let tv_width = window.$("#tv").outerWidth();
        window.$("#tv").css("height", tv_width / 1.77);
      });
    });

    window.$(document).ready(function () {
      let floor_height = window.$(".game_console_wrap").outerHeight();
      window.$(".bg-floor").css("height", floor_height);

      window.$(window).resize(function () {
        let floor_height = window.$(".game_console_wrap").outerHeight();
        window.$(".bg-floor").css("height", floor_height);
      });
    });
    // setBannerMessage("Please wait~");
    // setWaiting(true);

    let soundset = localStorage.getItem("soundsetting");
    // console.log("soundset =>", soundset);
    // console.log("soundset type of =>", typeof soundset);
    if (soundset === null) {
      localStorage.setItem("soundsetting", "true");
      setSoundOn(true);
    } else {
      if (soundset === "true") {
        setSoundOn(true);
      } else {
        setSoundOn(false);
      }
    }
  }, []);

  useEffect(() => {
    if (initialized && !initcomplete) {
      startApp();
    }
  }, [initialized]);

  useEffect(() => {
    if (nftInstance !== null && account !== undefined && account.length > 0) {
      if (
        myinfo !== null &&
        myinfo !== undefined &&
        account !== myinfo.Address
      ) {
        // account changed
        navigate("/");
        return;
      }
      setBannerMessage("Shake Shake ~~");
      setWaiting(true);
      // My card List
      fetchMyCardBalance(account);
      getMyCards(account);
      // Master card List
      getMasterCards();

      getPlayData(account);
    }
  }, [nftInstance, account]);

  useEffect(() => {
    if (
      mycredit !== null &&
      mycredit !== undefined &&
      masterCards.length > 0 &&
      cardBalance >= 0
    ) {
      if (mycredit.Credit > 0) {
        if (cardBalance > 0) {
          if (myCards.length > 0) {
            getYourRandomChoices();
          }
        } else {
          getYourRandomChoices();
        }
      } else {
        setBannerMessage("No credit. Try tomorrow~");
        setWaiting(true);
      }
    }
  }, [mycredit, masterCards, myCards, cardBalance]);

  // Only Polygon Network
  const getMyCards = async _account => {
    // setGameCards
    let arrived_cards = [];
    for (let iy = 0; iy < 3; iy++) {
      try {
        arrived_cards = await nftInstance.tokensOf(_account);
      } catch (error) {
        console.log("getMyCards error  =>", error);
        continue;
      }
    }
    if (arrived_cards.length > 0) {
      // console.log("arrived_cards =>", arrived_cards);
      setMyCards(arrived_cards);
    }
    return arrived_cards;
  };

  const getMasterCards = async () => {
    // setGameCards
    let master_cards = [];
    for (let iy = 0; iy < 3; iy++) {
      try {
        master_cards = await nftInstance.tokensOf(
          contractInfo[networkId].MasterAddress
        );
      } catch (error) {
        console.log("getMasterCards error  =>", error);
        continue;
      }
    }
    // console.log("master_cards =>", master_cards);
    if (master_cards.length > 0) {
      // console.log("arrived_cards =>", arrived_cards);
      setMasterCards(master_cards);
    }
    return master_cards;
  };

  const fetchMyCardBalance = async _account => {
    // My card
    for (let iy = 0; iy < 3; iy++) {
      try {
        setCardBalance((await nftInstance.balanceOf(_account)).toNumber());
      } catch (error) {
        console.log("fetchMyCardBalance error  =>", error);
        continue;
      }
    }
  };

  // const fetchMasterCardBalance = async () => {
  //   // Master card
  //   setMasterCardBalance(
  //     (
  //       await nftInstance.balanceOf(contractInfo[networkId].MasterAddress)
  //     ).toNumber()
  //   );
  // };

  const getPlayData = async _account => {
    try {
      // MyInfo
      let my_info;
      my_info = await postData(appProp.getuserinfoURL, {
        address: _account
      });
      if (my_info !== null) {
        if (my_info === undefined) {
          // 사용자 등록 안된 상태이면 main으로 이동
          // update User info
          // let updateUserInfo = await postData(appProp.updateuserURL, {
          //   address: _account
          // });
          // if (updateUserInfo) {
          //   my_info = await postData(appProp.getuserinfoURL, {
          //     address: _account
          //   });
          // }
          navigate("/");
        }
        setMyInfo(my_info);
      }

      // MyPoint
      let my_record = await postData(appProp.myrecordURL, {
        address: _account
      });

      if (my_record !== null && my_record !== undefined) {
        setMyPoint(my_record.Totalpoint);
      }

      // Credit
      let my_credit = await postData(appProp.mycreditURL, {
        address: _account
      });

      if (my_credit !== null) {
        setMyCredit(my_credit);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const startApp = async () => {
    try {
      // if (!verified) {
      //     return
      // }
      if (initialized && verified) {
        setInitComplete(true);
        let nftInst = new ethers.Contract(
          contractInfo[networkId].MainCardAddress,
          ABI,
          provider.current
        );

        setNftInstance(nftInst);

        getElem("consoleimg_r").style.display = "block";
        getElem("consoleimg_g").style.display = "block";
        getElem("tvimg_l").style.display = "block";
        getElem("tvimg_r").style.display = "block";
        getElem("tvimg_you_l").style.display = "block";
        getElem("tvimg_you_r").style.display = "block";
      } else {
        getElem("consoleimg_r").style.display = "none";
        getElem("consoleimg_g").style.display = "none";
        getElem("tvimg_l").style.display = "none";
        getElem("tvimg_r").style.display = "none";
        getElem("tvimg_you_l").style.display = "none";
        getElem("tvimg_you_r").style.display = "none";
      }
    } catch (error) {
      console.log(error);
    }
  };

  function connectWallet() {
    setWalletConnect(true);
  }

  const getYourRandomChoices = async () => {
    // console.log("*** getYourRandomChoices");
    setBannerMessage("Shake Shake ~~");
    setWaiting(true);
    // if (!verified) {
    //   alert("Please verify you first!");
    //   return;
    // }
    let _player_info = { isMaster: false, Address: "", discordId: "" };
    setPlayerInfo(_player_info);

    setGameCards([]);

    let cards = await getRandomCards(numberOfCardsPerGame);
    // console.log("cards => ", cards);
    var htmlStr = "";
    if (cards.length > 0) {
      cards.forEach(card => {
        setSelectedTokenGenes(card.rps);
        setSelectedTokenImage(card.image);
        setSelectedTokenID(card.tokenID);
      });

      // setWaiting(false);
      // getElem("msg_box_started").style.display = "none";

      setGameCards([...cards]);
      setCardPrepared(true);
      document.getElementById("btn_start").focus();
      setWaiting(false);
    } else {
      setWaiting(false);
      setBannerMessage(
        "Click on the card image on the left to get a new card."
      );
      setWaiting(true);
    }
  };

  const getRandomCards = async numberOfCardsPerGame => {
    let cards = [];

    // console.log("***** myCards =>", myCards);
    // console.log("***** masterCards =>", masterCards);

    for (let i = 0; i < numberOfCardsPerGame; i++) {
      let tokenID;

      if (mycredit.Credit > masterCardCnt) {
        // use my card
        tokenID = myCards[Math.floor(Math.random() * myCards.length)];
      } else {
        // use master card
        if (masterCards !== undefined && masterCards.length > 0) {
          tokenID = masterCards[Math.floor(Math.random() * masterCards.length)];
        }
      }
      // console.log("*** tokenID =>", tokenID);
      // console.log("*** tokenID.tonumber() =>", tokenID.toNumber());

      try {
        let g1 = [];
        let RPScard1;
        let tokenInfoBase64;
        let jsonInfo;
        let tokenInfo = await postData(appProp.getnftinfoURL, {
          tokenid: tokenID.toNumber()
        });
        // console.log("tokenInfo gene =>", tokenInfo.genes);
        // console.log("tokenInfo svg =>", tokenInfo.svg);

        if (tokenInfo !== undefined && tokenInfo !== null) {
          let genes = tokenInfo.genes;
          g1 = genes.split(",").map(Number);
          // console.log("g1 =>", g1);

          RPScard1 = g1.map(x => {
            return (x % 3) + 1;
          });
          jsonInfo = tokenInfo.svg;
        }

        if (RPScard1 !== undefined && jsonInfo !== undefined) {
          cards.push({
            tokenID: tokenID.toNumber(),
            image: jsonInfo,
            rps: RPScard1
          });
        }
      } catch (error) {
        console.log(error);
      }
    }

    return cards;
  };

  ///////////////

  const [showChoiceButtons, setShowChoiceButtons] = useState(false);

  let myRemovedCard = useRef(0);
  let ws = useRef(null);

  const makePairs = () => {
    let numCards = gameCards.length;
    let pairs = [];

    for (let i = 0; i < numCards; i++) {
      let sourceArrary = gameCards[i].rps;
      pairs.push([sourceArrary[0], sourceArrary[1]]);
      pairs.push([sourceArrary[2], sourceArrary[3]]);
      pairs.push([sourceArrary[4], sourceArrary[5]]);
      pairs.push([sourceArrary[6], sourceArrary[7]]);
    }

    // console.log("Combat Pairs", pairs);

    return pairs;
  };

  const runGame = async e => {
    setCardSelected(false); // true : big hand , false : small hand
    setCardPrepared(false);
    setMyRPS1Image(null);
    setMyRPS2Image(null);
    setCptyRPS1Image(null);
    setCptyRPS2Image(null);
    getElem("credit_point").innerHTML = `0 / ${mypoint} Points`;
    runRPSMinusOne(account, makePairs(), appProp);
  };

  const runRPSMinusOne = (account, pairs, appProp) => {
    const authToken = "DUMMYTOKEN";

    const getPlayerInfo = async _cpty_address => {
      // getPlayerInfo
      let _player_info = { isMaster: false, Address: "", discordId: "" };
      console.log("getPlayerInfo _cpty_address =>", _cpty_address);
      if (_cpty_address === "0xMASTER") {
        _player_info.isMaster = true;
        _player_info.Address = "";
        _player_info.discordId = "MASTER";
        setPlayerInfo(_player_info);
      } else {
        _player_info.isMaster = false;
        _player_info.Address = _cpty_address;
        let tmp_player = await postData(appProp.getuserinfoURL, {
          address: _cpty_address
        });
        console.log("tmp_player =>", tmp_player);
        if (tmp_player.Discordid.length > 0) {
          _player_info.discordId = tmp_player.Discordid;
        } else {
          _player_info.discordId = "";
        }
        setPlayerInfo(_player_info);
      }
    };

    ws.current = new WebSocket(appProp.gameServerURL);

    let response;
    let currentRound = 0;
    let myRPS1, myRPS2;
    let myPoints = 0;
    ws.current.addEventListener("open", function (event) {
      ws.current.send(
        JSON.stringify({
          cmd: REQ_CONNECT,
          address: account,
          auth_token: authToken
        })
      );
    });

    ws.current.addEventListener("message", e => {
      let recData = JSON.parse(e.data);

      switch (recData.cmd) {
        case WAIT_GAME:
          // console.log(recData);
          // show waiting sign
          if (soundOn) wait_audio.play();
          setBannerMessage("Waiting");
          setWaiting(true);
          break;

        case START_GAME:
          // console.log(recData);

          // Player Info
          getPlayerInfo(recData.cpty_address);

          myRemovedCard.current = 0;

          myRPS1 = pairs[currentRound][0];
          myRPS2 = pairs[currentRound][1];
          response = {
            cmd: MY_CARDS,
            card1: myRPS1,
            card2: myRPS2
          };

          setWaiting(false);
          // getElem("msg_box_started").style.display = "none";
          // console.log("(first round) MY CARDS", response);
          ws.current.send(JSON.stringify(response));
          break;

        case REJECT_GAME:
          setBannerMessage("No credit. Try tomorrow~");
          setWaiting(true);
          console.log("game is rejected since", recData.message);
          break;

        case CPTY_CARDS:
          // console.log("CPTY_CARDS", recData);
          setCardSelected(false); // true : big hand , false : small hand_click
          setMyRPS1Image(RPSSign[myRPS1]);
          setMyRPS2Image(RPSSign[myRPS2]);

          setCptyRPS1Image(RPSSign[recData.card1]);
          setCptyRPS2Image(RPSSign[recData.card2]);

          myRemovedCard.current = 0;
          clearInterval(counter);
          clearTimeout(timerAutoChoice);
          setShowChoiceButtons(true);

          // show countdown
          if (soundOn) wait_audio.pause();
          timer_audio.loop = true;
          if (soundOn) timer_audio.play();
          showCount = pegiWait;
          var countDown = getElem("countdown");
          countDown.innerText = showCount;
          countDown.style.display = "block";

          counter = setInterval(() => {
            if (showCount == 0) {
              countDown.style.display = "none";
              clearInterval(counter);
            } else {
              countDown.innerText = showCount;
              showCount -= 1;
            }
          }, 1000);

          // after 3 seconds, if showChoiceButtions == true, run chooseSecond
          timerAutoChoice = setTimeout(() => {
            if (myRemovedCard.current === 0) {
              clearTimeout(timerAutoChoice);
              setShowChoiceButtons(false);
              showCount = 0;
              myRemovedCard.current = 2;
              ws.current.send(
                JSON.stringify({ cmd: REMOVE_CARD, removed_card_num: 2 })
              );
            }
          }, pegiWait * 1000);

          break;

        case FINAL_RESULT:
          if (soundOn) timer_audio.pause();
          let msg_box_result = getElem("msg_box_result");
          // console.log("*** Final result", recData);
          // console.log(
          //   `currentRound: ${currentRound}, myRemovedCard: ${myRemovedCard.current}`
          // );

          // check the result
          //// check your card of 'final result' === your remaining card
          if (
            pairs[currentRound][2 - myRemovedCard.current] !==
            recData.your_choice
          ) {
            alert(
              `1. my choice is wrong - mine: ${
                pairs[currentRound][2 - myRemovedCard.current]
              } vs server ${recData.your_choice}`
            );
            ws.current.close(
              `1. my choice is wrong - mine: ${
                pairs[currentRound][2 - myRemovedCard.current]
              } vs server ${recData.your_choice}`
            );
            break;
          }
          if (myRemovedCard.current !== recData.your_removed_card_num) {
            alert(
              `2. my choice is wrong - mine: ${myRemovedCard.current} vs server ${recData.your_removed_card_num}`
            );
            ws.current.close(
              `2. my choice is wrong - mine: ${myRemovedCard.current} vs server ${recData.your_removed_card_num}`
            );
            break;
          }
          //// check RPS(you, cpty) === result in 'final result'
          // return -1 when c1 wins, 0 in draw, 1 when c2 wins
          let rpsResult = RPS(recData.cpty_choice, recData.your_choice);
          if (rpsResult !== recData.result) {
            alert(
              `3. RPS result is wrong - RPS: ${rpsResult} vs server ${recData.result}`
            );
            ws.current.close(
              `3. RPS result is wrong - RPS: ${rpsResult} vs server ${recData.result}`
            );
            break;
          }
          if (rpsResult === 1) {
            // you won
            myPoints += 2;
            //// your self-calced points === point in 'final result'
            if (myPoints !== recData.point) {
              alert(
                `4. point result is wrong - mine: ${myPoints + 1} vs server ${
                  recData.point
                }`
              );
              ws.current.close(
                `4. point result is wrong - mine: ${myPoints + 1} vs server ${
                  recData.point
                }`
              );
              break;
            }

            setShowResult(true);
            msg_box_result.style.display = "block";
            setWin(true);
            if (soundOn) win_audio.play();
            setTimeout(() => {
              msg_box_result.style.display = "none";
              setShowResult(false);
              setWin(false);
            }, 1500);
          } else if (rpsResult === 0) {
            // you draw

            myPoints++;
            //// your self-calced points === point in 'final result'
            if (myPoints !== recData.point) {
              alert(
                `4. point result is wrong - mine: ${myPoints} vs server ${recData.point}`
              );
              ws.current.close(
                `4. point result is wrong - mine: ${myPoints} vs server ${recData.point}`
              );
              break;
            }
            setShowResult(true);
            msg_box_result.style.display = "block";
            setDraw(true);

            setTimeout(() => {
              msg_box_result.style.display = "none";
              setShowResult(false);
              setDraw(false);
            }, 1500);
          } else {
            // you lose
            if (soundOn) loose_audio.play();
            setShowResult(true);
            msg_box_result.style.display = "block";
            setLose(true);

            setTimeout(() => {
              msg_box_result.style.display = "none";
              setShowResult(false);
              setLose(false);
            }, 1500);
          }

          if (recData.your_removed_card_num === 1) {
            setMyRPS1Image(null);
          } else {
            setMyRPS2Image(null);
          }

          if (recData.cpty_removed_card_num === 1) {
            setCptyRPS1Image(null);
          } else {
            setCptyRPS2Image(null);
          }
          setCardSelected(true); // true : big hand , false : small hand_click

          let latestpoint = mypoint + myPoints;
          setMyPoint(latestpoint);
          getElem(
            "credit_point"
          ).innerHTML = `${myPoints} / ${latestpoint} Points`;

          // for the next round
          currentRound++;
          // console.log(`new round: ${currentRound}`);
          if (currentRound < numberOfRoundsPerCard * numberOfCardsPerGame) {
            // console.log(`new round started: ${currentRound}`);

            myRPS1 = pairs[currentRound][0];
            myRPS2 = pairs[currentRound][1];
            response = {
              cmd: MY_CARDS,
              card1: myRPS1,
              card2: myRPS2
            };

            // console.log("(new round) MY CARDS", response);
            ws.current.send(
              JSON.stringify({
                cmd: MY_CARDS,
                card1: myRPS1,
                card2: myRPS2
              })
            );
          } else {
            // // show final result!!!!

            // show countdown
            // var resultMessageLine = getElem("finalResult");
            // resultMessageLine.style.display = 'block';
            // resultMessageLine.innerText = `You've got ${myPoints} points`
            let tmp_mycredit = mycredit;
            tmp_mycredit.Credit = mycredit.Credit - 1;
            setMyCredit(tmp_mycredit);
            setBannerMessage(`You've got ${myPoints} points`);
            setWaiting(true);
            setTimeout(() => {
              setMyRPS1Image(null);
              setMyRPS2Image(null);
              setCptyRPS1Image(null);
              setCptyRPS2Image(null);
              setWaiting(false);
              setCurRound(0);
              // Pick random card
              if (tmp_mycredit.Credit > 0) {
                getYourRandomChoices();
                getElem("credit_point").innerHTML = `0 / ${latestpoint} Points`;
              } else {
                setBannerMessage("No credit. Try tomorrow~");
                setWaiting(true);
              }

              // resultMessageLine.style.display = 'none';
            }, 3000);

            // server closes connection.
            // ws.current.close('round ended');
          }
          break;

        default:
          console.log(`abnormal message from server - ${recData}`);
      }
    });

    ws.current.addEventListener("close", e => {
      console.log("network is closed");
    });
  };

  const chooseFirst = () => {
    // console.log('choose first', myRemovedCard.current, ws.current);
    if (soundOn) timer_audio.pause();
    if (soundOn) click_audio.play();
    if (myRemovedCard.current === 0 && ws.current != null) {
      setShowChoiceButtons(false);
      showCount = 0;
      // console.log("MY Choice is 1");
      myRemovedCard.current = 2;
      RoundCount();

      ws.current.send(
        JSON.stringify({ cmd: REMOVE_CARD, removed_card_num: 2 })
      );
    }
  };

  const chooseSecond = () => {
    // console.log('choose second', myRemovedCard.current);
    if (soundOn) timer_audio.pause();
    if (soundOn) click_audio.play();
    if (myRemovedCard.current === 0 && ws.current != null) {
      setShowChoiceButtons(false);
      showCount = 0;
      // console.log("MY Choice is 2");
      myRemovedCard.current = 1;

      RoundCount();
      ws.current.send(
        JSON.stringify({ cmd: REMOVE_CARD, removed_card_num: 1 })
      );
    }
  };

  const RoundCount = () => {
    // Round Num
    let _curR = curRound + 1;
    setCurRound(_curR);
  };

  const changeCard = () => {
    if (mycredit.Credit > 0) {
      getYourRandomChoices();
    }
  };

  const bounceplay = () => {
    // console.log("bounceplay soundOn =>", soundOn);
    // console.log("bounceplay typeof soundOn", typeof soundOn);
    if (soundOn) {
      // console.log("엥???");
      bounce_audio.play();
    }
  };

  const soundSetting = _onoff => {
    // console.log("soundSetting onoff  =>", _onoff);
    // console.log("soundSetting onoff typeof =>", typeof _onoff);
    setSoundOn(_onoff);
    localStorage.setItem("soundsetting", _onoff.toString());
  };

  window.addEventListener("keydown", e => {
    // console.log("keydown =>", e.key);
    switch (e.key) {
      case "ArrowUp":
        document.getElementById("btn_start").focus();
        break;
      case "ArrowLeft":
      case "a":
        document.getElementById("btn_red").focus();
        break;
      case "ArrowRight":
      case "s":
        document.getElementById("btn_green").focus();
        break;
    }
  });

  return (
    <div id="play">
      <div className="wrap">
        <content className="play_content">
          <input type="checkbox" id="header_btn" />
          <header className="play_header">
            <div>
              <Link to="/" className="logo">
                <img src={title_img} alt="" />
              </Link>

              <label htmlFor="header_btn" className="header_btn">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </label>

              <div id="my_info">
                {initialized && myinfo !== null && myinfo !== undefined ? (
                  <>
                    <div id="adress">
                      <img src={ico_wallet} alt="" />
                      <div id="connected_wallet">
                        <p>
                          {myinfo.Address.length > 0
                            ? myinfo.Address.substring(0, 6) +
                              "      ...      " +
                              myinfo.Address.substring(
                                myinfo.Address.length - 4,
                                myinfo.Address.length
                              )
                            : ""}
                        </p>
                        {myinfo.Teamname != null &&
                        myinfo.Teamname.length > 0 ? (
                          <div id="discord_info">
                            <p>
                              {/* <span id="team_color"></span> */}
                              <span id="team_name">
                                Team : {myinfo.Teamname}
                              </span>
                            </p>
                            <br></br>
                            <p id="discord_id">ID : {myinfo.Discordid}</p>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    <div id="my_point">
                      <img src={ico_point} alt="" />
                      {/* <a href="" alt=""> */}
                      <p>
                        {mypoint} <span>Point</span>
                      </p>
                      {/* <p className="caption">나의 총 point입니다.</p> */}
                      {/* </a> */}
                    </div>

                    {selectedTokenImage !== null ? (
                      <>
                        <div id="card_random">
                          <img src={ico_card} alt="" />
                          <div id="card_info">
                            <img
                              src={selectedTokenImage}
                              alt="Get Card"
                              onClick={changeCard}
                              style={{ cursor: "pointer" }}
                              onMouseEnter={() => bounceplay()}
                            />
                            <p>
                              <span id="token_id">
                                Leedo NFT #{selectedTokenID}
                              </span>
                              {mycredit.Credit <= masterCardCnt ? (
                                <span id="card_owner">Master Card</span>
                              ) : (
                                ""
                              )}
                            </p>
                          </div>
                          =
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </>
                ) : (
                  <div>
                    <img src={ico_wallet} alt="" />
                    <button
                      id="btn_connect"
                      type="button"
                      onClick={connectWallet}
                    >
                      Connect Wallet
                    </button>
                  </div>
                )}

                <div id="rankings">
                  <img src={ico_crown} alt="" />
                  <input type="checkbox" id="rankings_btn" />
                  <Link to="/ranking" onMouseEnter={() => bounceplay()}>
                    <span></span>
                    Rankings
                  </Link>
                </div>

                <div id="instruction">
                  <img src={ico_instruction} alt="" />
                  <input type="checkbox" id="instruction_btn" />
                  <label
                    htmlFor="instruction_btn"
                    onMouseEnter={() => bounceplay()}
                  >
                    Instruction
                  </label>
                  <div className="popup">
                    <div className="instruction_contents">
                      <label
                        htmlFor="instruction_btn"
                        className="close"
                      ></label>
                      <div className="text">
                        <Instruction></Instruction>
                      </div>
                    </div>
                    <label htmlFor="instruction_btn"></label>
                  </div>
                </div>
                <div id="soundsetting">
                  <img src={soundOn ? ico_sound_on : ico_sound_off} alt="" />
                  <label
                    htmlFor="soundsetting_btn"
                    onMouseEnter={() => bounceplay()}
                    onClick={() => soundSetting(!soundOn)}
                  >
                    Sound on/off
                  </label>
                </div>
              </div>
            </div>
          </header>

          <div id="game_warp">
            <div className="bg-floor"></div>
            <label htmlFor="header_btn" className="label_out"></label>
            <span className="tableImg"></span>

            {waiting && (
              <div className="msg_box" id="msg_box_ready">
                <div className="msg_waitiing">
                  <div className="loader"></div>
                  <h3>{bannerMessage}</h3>
                </div>
              </div>
            )}

            {/* <!-- msg_box end --> */}
            <div className="msg_box" id="msg_box_started">
              <div className="msg_started">
                <h3>Started!</h3>
              </div>
            </div>
            {/* <!-- msg_box end --> */}

            <div className="msg_box" id="msg_box_rps">
              <div className="msg_rps">
                <h3>가위바위보!</h3>
              </div>
            </div>

            <div className="msg_box" id="msg_box_count">
              <div className="msg_count">
                <p>하나빼기!</p>
                <h2>3</h2>
              </div>
            </div>

            <div className="msg_box" id="msg_box_result">
              {finalwin && (
                <div className="msg_result" id="result_win">
                  <p>[Game {curRound}]</p>
                  <img src={win_img} alt="" />
                  <h2>Win</h2>
                </div>
              )}

              {finallose && (
                <div className="msg_result" id="result_lose">
                  <p>[Game {curRound}]</p>
                  <img src={loose_img} alt="" />
                  <h2>Lose</h2>
                </div>
              )}

              {finaldraw && (
                <div className="msg_result" id="result_draw">
                  <p>[Game {curRound}]</p>
                  <img src={draw_img} alt="" />
                  <h2>Draw</h2>
                </div>
              )}
            </div>

            <div id="game">
              <div id="tv">
                {playerInfo !== null && playerInfo !== undefined ? (
                  <div id="player_info" className="zoomin">
                    {playerInfo.isMaster ? (
                      // {/* <!-- 상대가 마스터일 때 --> */}
                      <div id="player_info_master">
                        <span></span>
                        <p>Player : </p>
                        <img src={icon_master} alt="" />
                        <p>Master</p>
                      </div>
                    ) : (
                      // {/* <!-- 상대가 사람일 때 --> */}
                      <div id="player_info_uesr">
                        <span></span>
                        <p>
                          Player :{" "}
                          {playerInfo.discordId.length > 0
                            ? playerInfo.discordId
                            : playerInfo.Address}
                        </p>
                      </div>
                    )}
                  </div>
                ) : (
                  ""
                )}
                <div className="tv_img">
                  <div id="countdown"></div>

                  <div className="tv_inner">
                    {/* <!-- plus "tvimg" idv --> */}
                    <div className="player">
                      <h6>Player</h6>
                      <div className="hand_wrap">
                        <img
                          id="tvimg_l"
                          className={
                            cardSelected
                              ? "hand hand_left select"
                              : "hand hand_left"
                          }
                          src={cptyRPS1Image}
                          alt=""
                        />
                        <img
                          id="tvimg_r"
                          className={
                            cardSelected
                              ? "hand hand_right select"
                              : "hand hand_right"
                          }
                          src={cptyRPS2Image}
                          alt=""
                        />
                      </div>
                    </div>

                    <div className="you">
                      <h6>You</h6>
                      <div className="hand_wrap">
                        <img
                          className={
                            cardSelected
                              ? "hand hand_left select"
                              : "hand hand_left"
                          }
                          id="tvimg_you_l"
                          src={myRPS1Image}
                          alt=""
                        />
                        <img
                          className={
                            cardSelected
                              ? "hand hand_right select"
                              : "hand hand_right"
                          }
                          id="tvimg_you_r"
                          src={myRPS2Image}
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                  {/* <!-- tv_inner end --> */}
                </div>
              </div>

              <div className="game_console_wrap">
                <div className="game_console">
                  {/* <!-- plus "consoleimg" idv --> */}
                  <div id="start">
                    <button
                      id="btn_start"
                      type="button"
                      onClick={runGame}
                      disabled={!cardPrepared}
                      onMouseEnter={() => bounceplay()}
                    >
                      Start
                    </button>
                  </div>

                  <div className="game_console_btn_wrap">
                    <button
                      type="button"
                      className="game_console_btn red"
                      id="btn_red"
                      value="0"
                      onClick={chooseFirst}
                      onMouseEnter={() => bounceplay()}
                    >
                      <img id="consoleimg_r" src={myRPS1Image} alt="" />
                    </button>
                    <button
                      type="button"
                      className="game_console_btn green"
                      id="btn_green"
                      value="0"
                      onClick={chooseSecond}
                      onMouseEnter={() => bounceplay()}
                    >
                      <img id="consoleimg_g" src={myRPS2Image} alt="" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="game_count zoomin">
              <span class="game_count_icon">
                <img src={icon_credit} alt="" />
              </span>
              {mycredit !== null &&
              mycredit.Credit !== null &&
              mycredit.Credit !== undefined ? (
                <div id="game_count">
                  Credit : {mycredit.Credit}
                  {/* {mycredit.Credit +
                    "/" +
                    parseInt(mycredit.Balance + masterCardCnt)} */}
                </div>
              ) : (
                ""
              )}
            </div>

            <div className="points zoomin">
              <span className="points_icon">
                <img src={ico_point} alt="" />
              </span>
              <div id="credit_point">0 / {mypoint} Points</div>
            </div>
          </div>
          {/* <!-- game_warp end --> */}
        </content>
      </div>
    </div>
  );
};

export default HanapegiPlay;
